import './CaseStudies.scss';

ComponentManager.init(document.body);

let filter = function () {

  //defines
  const btnServices = document.getElementById("btnServicesTechnologies");
  const btnTypes = document.getElementById("btnTypes");
  const typeServices = document.getElementById('toggle-services');
  const typeTechnologies = document.getElementById('toggle-technologies');
  const typePlaceholder = document.getElementById('btnTypes').dataset.placeholder;

  function checkIfFoundRecords() {
    const caseStudiesItems = document.querySelectorAll('.ThumbCaseStudyV3');
    const notFound = document.getElementById('not-found');

    for (let j = 0; j < caseStudiesItems.length; j++) {

      if (caseStudiesItems[j].offsetWidth > 0 && caseStudiesItems[j].offsetHeight) {

        notFound.style.display = 'none';
        break;

      } else {

        notFound.style.display = 'block';
        continue;

      }
    }
  }

  //services popup
  const eleServices = document.querySelectorAll('[data-toggle-services');
  for (let i = 0; i < eleServices.length; i++) {
    let self = eleServices[i];
    self.addEventListener('click', function (event) {
      let name = this.getAttribute('data-toggle-services');
      if (name == "all") {
        btnTypes.innerHTML = "All types";
      } else {
        btnTypes.innerHTML = name;
      }

      btnServices.innerHTML = name;
      btnTypes.innerHTML = typePlaceholder;

      if (name == 'Services') {
        typeServices.classList.add('active');
        typeTechnologies.classList.remove('active');
      } else {
        typeTechnologies.classList.add('active');
        typeServices.classList.remove('active');
      }


      const caseStudiesItems = document.querySelectorAll('.ThumbCaseStudyV3');
      for (let j = 0; j < caseStudiesItems.length; j++) {
        caseStudiesItems[j].style.display = 'block';
      }

      checkIfFoundRecords();
    }, false);
  }



  //types popup
  const eleTypes = document.querySelectorAll('[data-toggle-types');
  for (let i = 0; i < eleTypes.length; i++) {
    let self = eleTypes[i];
    self.addEventListener('click', function (event) {
      let name = this.getAttribute('data-toggle-types');
      if (name == "all") {
        btnTypes.innerHTML = "All types";
      } else {
        btnTypes.innerHTML = name;
      }
      const caseStudiesItems = document.querySelectorAll('.ThumbCaseStudyV3');
      for (let j = 0; j < caseStudiesItems.length; j++) {
        let string = caseStudiesItems[j].getAttribute('data-filter');
        console.log(string)
        let array = string.split(",");

        let contains = array.includes(name);
        if (name == "all") {
          caseStudiesItems[j].style.display = 'block';
        }
        else {
          caseStudiesItems[j].style.display = 'none';
          if (contains) {
            caseStudiesItems[j].style.display = 'block';
          }
        }
      }


      checkIfFoundRecords();
    }, false);
  }


}();
